import { useState } from 'react';
import { comments } from '@/mocks/home';

const avatarTone = [
  'bg-primary-500 text-background-50 dark:text-foreground-950',
  'bg-accent-500 text-background-50 dark:text-foreground-950',
  'bg-secondary-500 text-background-50 dark:text-foreground-950',
  'bg-foreground-800 text-background-50 dark:text-foreground-950',
  'bg-primary-700 text-background-50 dark:text-foreground-950',
  'bg-secondary-700 text-background-50 dark:text-foreground-950',
];

export default function CommentWall() {
  const [likes, setLikes] = useState<Record<string, boolean>>({});

  const toggle = (id: string) => {
    setLikes((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="comments" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-3">
            <span className="h-6 w-1.5 rounded-full bg-secondary-500"></span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              吃瓜现场
            </h2>
          </div>
          <p className="text-sm text-foreground-600">网友正在讨论今日爆料，理性吃瓜</p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="space-y-3">
              {comments.map((c, idx) => (
                <div
                  key={c.id}
                  className="flex gap-4 rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-heading text-sm font-bold ${
                      avatarTone[idx % avatarTone.length]
                    }`}
                  >
                    {c.initial}
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="text-sm font-semibold text-foreground-950">{c.name}</span>
                      <span className="text-xs text-foreground-500">{c.time}</span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.text}</p>
                    <button
                      type="button"
                      onClick={() => toggle(c.id)}
                      className={`mt-3 flex cursor-pointer items-center gap-1.5 text-xs transition-colors ${
                        likes[c.id] ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600'
                      }`}
                    >
                      <i className={likes[c.id] ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                      {c.likes + (likes[c.id] ? 1 : 0)}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950">说点什么</h3>
              <p className="mt-1 text-xs text-foreground-500">分享你的吃瓜线索，友好讨论</p>
              <div className="mt-4 space-y-3">
                <input
                  type="text"
                  placeholder="你的昵称"
                  className="w-full rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400"
                />
                <textarea
                  rows={4}
                  maxLength={500}
                  placeholder="聊聊你对今日爆料的看法…"
                  className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400"
                />
                <button
                  type="button"
                  className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-send-plane-fill"></i>
                  发表评论
                </button>
                <p className="text-center text-[11px] text-foreground-500">
                  展示用评论区，内容不会真实提交
                </p>
              </div>
            </div>

            <div className="mt-4 rounded-2xl border border-accent-200 bg-accent-50 p-5">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-lg text-accent-700"></i>
                <span className="font-heading text-sm font-bold text-accent-900">吃瓜提示</span>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-accent-900/80">
                本站内容均为网络整理，仅供参考娱乐。请保持理性，不信谣、不传谣。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}